import { z } from "zod";
/**
 * Message types for WebSocket communication
 */
export var MessageType;
(function (MessageType) {
    MessageType["USER_MESSAGE"] = "USER_MESSAGE";
    MessageType["ADMIN_MESSAGE"] = "ADMIN_MESSAGE";
    MessageType["ASSISTANT_MESSAGE"] = "ASSISTANT_MESSAGE";
})(MessageType || (MessageType = {}));
/**
 * Session modes - determines who responds to messages
 */
export var SessionMode;
(function (SessionMode) {
    SessionMode["AUTO"] = "AUTO";
    SessionMode["MANUAL"] = "MANUAL";
})(SessionMode || (SessionMode = {}));
/**
 * Metadata field for messages (flexible object)
 */
export const messageMetadataSchema = z
    .record(z.string(), z.unknown())
    .optional();
/**
 * Base message schema
 */
export const baseMessageSchema = z.object({
    id: z.string().uuid(),
    type: z.nativeEnum(MessageType),
    session_id: z.string().uuid(),
    content: z.string(),
    sender_id: z.string(),
    sender_name: z.string().optional(),
    metadata: messageMetadataSchema,
    created_at: z.string().datetime(),
});
/**
 * User message schema
 */
export const userMessageSchema = baseMessageSchema.extend({
    type: z.literal(MessageType.USER_MESSAGE),
});
/**
 * Admin message schema
 */
export const adminMessageSchema = baseMessageSchema.extend({
    type: z.literal(MessageType.ADMIN_MESSAGE),
    sender_name: z.string(), // Required for admin messages
});
/**
 * Assistant message schema
 */
export const assistantMessageSchema = baseMessageSchema.extend({
    type: z.literal(MessageType.ASSISTANT_MESSAGE),
});
/**
 * Schema for incoming message from client
 */
export const incomingMessageSchema = z.object({
    type: z.enum(MessageType),
    content: z
        .string()
        .min(1, "Message content is required")
        .max(2000, "Message is too long (max 2000 characters)"),
    metadata: messageMetadataSchema,
});
/**
 * Socket events emitted by server
 */
export var ServerSocketEvent;
(function (ServerSocketEvent) {
    ServerSocketEvent["CONNECTED"] = "connected";
    ServerSocketEvent["MESSAGE"] = "message";
    ServerSocketEvent["SESSION_CREATED"] = "session_created";
    ServerSocketEvent["SESSION_MODE_CHANGED"] = "session_mode_changed";
    ServerSocketEvent["SESSION_CLOSED"] = "session_closed";
    ServerSocketEvent["ERROR"] = "error";
    // Streaming events for AI responses
    ServerSocketEvent["ASSISTANT_STREAM_START"] = "assistant_stream_start";
    ServerSocketEvent["ASSISTANT_STREAM_CHUNK"] = "assistant_stream_chunk";
    ServerSocketEvent["ASSISTANT_STREAM_END"] = "assistant_stream_end";
})(ServerSocketEvent || (ServerSocketEvent = {}));
/**
 * Socket events emitted by client
 */
export var ClientSocketEvent;
(function (ClientSocketEvent) {
    ClientSocketEvent["MESSAGE"] = "message";
    ClientSocketEvent["CHANGE_MODE"] = "change_mode";
    ClientSocketEvent["CLOSE_SESSION"] = "close_session";
})(ClientSocketEvent || (ClientSocketEvent = {}));
